<template>
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
  >
    <path d="M0.875 0.22C0.651325 0.22 0.47 0.401325 0.47 0.625C0.47 0.848675 0.651325 1.03 0.875 1.03H9.125C9.34867 1.03 9.53 0.848675 9.53 0.625C9.53 0.401325 9.34867 0.22 9.125 0.22H0.875ZM2.375 3.22C2.15132 3.22 1.97 3.40132 1.97 3.625C1.97 3.84868 2.15132 4.03 2.375 4.03H7.625C7.84868 4.03 8.03 3.84868 8.03 3.625C8.03 3.40132 7.84868 3.22 7.625 3.22H2.375ZM3.875 6.22C3.65132 6.22 3.47 6.40132 3.47 6.625C3.47 6.84868 3.65132 7.03 3.875 7.03H6.125C6.34868 7.03 6.53 6.84868 6.53 6.625C6.53 6.40132 6.34868 6.22 6.125 6.22H3.875Z" stroke-width="0.06"/>
  </svg>
</template>
